import { Skill } from "../Models";
import { APIURL } from "./config";

export const postSkill = async (skill: Skill | undefined, token: string) => {
  if (skill)
    await fetch(`${APIURL}/Skill`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ name: skill.name }),
    });
  return;
};

export const getSkillAnalytics = async (skillId: string, token: string) => {
  const res = await fetch(`${APIURL}/Skill/Stats?skillId=${skillId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  const json = res.json();
  return json;
};

export const updateSkillThreshold = async (
  skillId: string,
  thresholdVal: number,
  token: string
) => {
  await fetch(`${APIURL}/Skill/Threshold/${skillId}/${thresholdVal}`, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return;
};

export const fetchAllSkills = async (token: string) => {
  const res = await fetch(`${APIURL}/Skill`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  const json = await res.json();
  return json;
};

export const getQuestionSkill = async (questionId: string, token: string) => {
  const res = await fetch(
    `${APIURL}/QuestionSkillMappingControllers/${questionId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const json = await res.json();
  return json;
};

export const postQuestionSkill = async (
  questionId: string | undefined,
  skills: Skill[],
  token: string
) => {
  const skillIds = await skills.map((s) => s.id);
  await fetch(
    `${APIURL}/QuestionSkillMappingControllers/Update/${questionId}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(skillIds),
    }
  );
  return;
};
